module.exports = __webpack_public_path__ + "img/invoice-de-male-banner-sn.57633d66.png";